import { AuthService } from './AuthService';
import { API_BASE_URL } from '../config/env';

const authService = new AuthService();

// fetch 요청을 감싸는 커스텀 함수
async function streamFetch(url: string, options: RequestInit = {}): Promise<Response> {
    try {
        // 토큰 가져오기
        const token = await authService.getAccessToken();
        
        // 기본 헤더와 사용자 정의 헤더 병합
        const headers = {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            ...options.headers,
        };

        // 요청 보내기
        const response = await fetch(`${API_BASE_URL}${url}`, {
            ...options,
            headers,
        });

        // 400 에러일 때 응답 내용 확인
        if (response.status === 400) {
            const errorData = await response.text();
            console.error('서버 응답 에러:', errorData);
            console.error('요청 본문:', options.body); // 에러 시 요청 본문도 함께 로깅
            throw new Error(`HTTP error! status: ${response.status}, message: ${errorData}`);
        }

        // 401 에러 처리 (토큰 만료)
        if (response.status === 401) {
            try {
                // 새 토큰 획득 시도
                const newToken = await authService.getAccessToken();
                
                // 새 토큰으로 재요청
                const retryResponse = await fetch(`${API_BASE_URL}${url}`, {
                    ...options,
                    headers: {
                        ...headers,
                        'Authorization': `Bearer ${newToken}`,
                    },
                });

                if (!retryResponse.ok) {
                    throw new Error(`HTTP error! status: ${retryResponse.status}`);
                }

                return retryResponse;
            } catch (e) {
                // Re-authentication required
                console.log("Re-authentication required");
                window.location.href = '/';
                throw new Error('Re-authentication required');
            }
        }

        // 기타 에러 처리
        if (!response.ok) {
            return Promise.reject(response);
        }

        return response;
    } catch (error) {
        throw error;
    } finally {
        // no-op; global fetch interceptor handles loading state
    }
}

export const api = {
  async get(url: string, options: RequestInit = {}) {
      return streamFetch(url, {
          ...options,
          method: 'GET',
      });
  },
  async post(url: string, data: any, options: RequestInit = {}) {
      return streamFetch(url, {
          ...options,
          method: 'POST',
          body: JSON.stringify(data),
      });
  },
};

let cachedToken: string | null = null;
let tokenExpiryTime: number | null = null;

// export async function getToken(): Promise<string> {
//     // 캐시된 토큰이 있고 만료되지 않았다면 그것을 사용
//     const currentTime = Date.now();
//     if (cachedToken && tokenExpiryTime && currentTime < tokenExpiryTime) {
//         return cachedToken;
//     }
    
//     // 새 토큰 획득
//     const token = await authService.getStorageAccessToken();
//     cachedToken = token;
//     // 토큰 만료 시간 설정 (예: 50분 후)
//     tokenExpiryTime = currentTime + 50 * 60 * 1000;
//     return token;
// }